import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { BehaviorSubject } from 'rxjs';
import { formatDate } from '@angular/common';
import { tPatientModel } from 'src/app/models/tPatientModel';
import { tPatientService } from '../tPatient.service';
import { tBookingInfoModel } from 'src/app/models/tBookingModel';
import { tBookingService } from '../tBooking.service';

// tslint:disable-next-line:max-line-length
import { CreateWaitingConsultDialogComponent } from 'src/app/components/create-waiting-consult-dialog/create-waiting-consult-dialog.component';

const TAG = 'CreateWaitingConsultService';

@Injectable({
    providedIn: 'root'
})
export class CreateWaitingConsultService {

    constructor(private log: LoggerService,
        private modalService: NgbModal
    ) { }

    // selectedPatient: tPatientModel;

    /**
     *
     * @param action
     * @param tableKeyValue
     * @param bookingNum
     * @param patientID
     * @param formCaseNum  1: arrive, 2: edit-booking
     * @param bkPatientName
     */
    openDialog(action: string, tableKeyValue: string, bookingNum: string, patientID: string,bkPatientName:string , formCaseNum: number, bkDoctorID?:string) {
        // console.log('open Dialog');
        this.log.d(TAG, 'open Dialog ,action = ' + action +
            ' , tableKeyValue = ' + tableKeyValue);

        const modalRef = this.modalService.open(CreateWaitingConsultDialogComponent, { size: 'xl', centered: true, backdrop: 'static', keyboard:false });

        // const modalRef = this.modalService.open(ModelComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.action = action;
        modalRef.componentInstance.status = status;
        modalRef.componentInstance.tableKeyValue = tableKeyValue;

        modalRef.componentInstance.bookingNum = bookingNum;
        modalRef.componentInstance.patientID = patientID;
        modalRef.componentInstance.formCaseNum = formCaseNum;
        modalRef.componentInstance.bkDoctorID = bkDoctorID;


         modalRef.componentInstance.bkPatientName = bkPatientName;
        // modalRef.componentInstance.bookingTimeSlotDisplay = bookingTimeSlotDisplay;
        // modalRef.componentInstance.bookingTimeSlotID = bookingTimeSlotID;

        return modalRef;

    }


}
